import { Types, theme } from '@fiverr-private/theme';
import { InputProps } from '../types';
import { formsTokenColors } from '../../shared/formsTokenColors';

export const generateBorderFocusWithin = ({
    isError,
    isSuccess,
}: {
    isError: InputProps['isError'];
    isSuccess: InputProps['isSuccess'];
}): Types.BorderColor => {
    const { validationError, validationSuccess } = theme.semanticBorderColors;

    if (isError) {
        return validationError;
    } else if (isSuccess) {
        return validationSuccess;
    } else {
        return formsTokenColors.interactiveColor;
    }
};
